"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _axios = _interopRequireDefault(require("axios"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _header = _interopRequireDefault(require("@insided/deprecated-control/header"));

var _Switcher = _interopRequireDefault(require("../control/Switcher"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Section = require("./Section");

var _SimpleFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/SimpleFilterSelector"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _utils = require("./utils");

var _TimezoneSelector = _interopRequireDefault(require("@insided/control/uikit/TimezoneSelector"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getUserRolesPlaceholderText = function getUserRolesPlaceholderText(selectedRoles) {
  var selectedUserRolesLength = selectedRoles === null || selectedRoles === void 0 ? void 0 : selectedRoles.length;

  if (selectedUserRolesLength === 0) {
    return 'Select user roles to exclude';
  }

  if (selectedUserRolesLength === 1) {
    return '1 user role selected';
  }

  return "".concat(selectedUserRolesLength, " user roles selected");
};

var PointSystemConfiguration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PointSystemConfiguration, _Component);

  var _super = _createSuper(PointSystemConfiguration);

  function PointSystemConfiguration(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PointSystemConfiguration);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "configurableActivityList", [{
      activityName: 'provided answer',
      points: 0
    }, {
      activityName: 'replied topic',
      points: 0
    }, {
      activityName: 'received like',
      points: 0
    }, {
      activityName: 'given like',
      points: 0
    }, {
      activityName: 'created topic',
      points: 0
    }]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "formattedTextForConfigurableActivities", {
      'provided answer': 'providing an answer',
      'replied topic': 'posting a reply',
      'received like': 'receiving a like or a vote',
      'given like': 'giving a like or upvoting an idea',
      'created topic': 'creating a topic'
    });
    _this.state = {
      activityList: [],
      selectedTimezone: '',
      timezoneList: [],
      messageType: null,
      message: '',
      isSaveButtonLoading: false,
      isUserRoleDropdownOpen: false,
      isUserRolesLoading: false,
      userRoles: [],
      selectedRoles: [],
      timezoneSelectionError: false
    };
    _this.combineActivityList = _this.combineActivityList.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUserRolesChanged = _this.onUserRolesChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetUserRoles = _this.onResetUserRoles.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchConfiguration = _this.fetchConfiguration.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchUserRoles = _this.fetchUserRoles.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2.default)(PointSystemConfiguration, [{
    key: "combineActivityList",
    value: function combineActivityList(configuration, customerConfiguration) {
      var defaultConfigurationObject = {};
      configuration.forEach(function (configurationItem) {
        defaultConfigurationObject[configurationItem.activityName] = {
          points: configurationItem.points,
          enabled: Boolean(configurationItem.enabled)
        };
      });
      var customerConfigurationObject = {};
      customerConfiguration.forEach(function (configurationItem) {
        customerConfigurationObject[configurationItem.activityName] = {
          points: configurationItem.points,
          enabled: !!configurationItem.enabled
        };
      });

      var combinedConfigurationObject = _objectSpread(_objectSpread({}, defaultConfigurationObject), customerConfigurationObject);

      return Object.keys(combinedConfigurationObject).map(function (combinedConfigurationItem) {
        return {
          activityName: combinedConfigurationItem,
          points: combinedConfigurationObject[combinedConfigurationItem].points,
          enabled: combinedConfigurationObject[combinedConfigurationItem].enabled
        };
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: null,
                  isUserRolesLoading: true
                });
                this.fetchConfiguration();
                this.fetchUserRoles();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchConfiguration",
    value: function () {
      var _fetchConfiguration = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var res, configuration;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios.default.get('/settings/pointSystem/configuration');

              case 3:
                res = _context2.sent;
                configuration = this.configurableActivityList;

                if (res.data) {
                  if (res.data.activityList) {
                    configuration = this.combineActivityList(this.configurableActivityList, res.data.activityList);
                  }

                  if (res.data.timezone) {
                    this.setState({
                      selectedTimezone: res.data.timezone
                    });
                  }

                  if (res.data.timezoneList) {
                    this.setState({
                      timezoneList: res.data.timezoneList
                    });
                  }

                  if (res.data.excludedUserRoles) {
                    this.setState({
                      selectedRoles: res.data.excludedUserRoles
                    });
                  }
                }

                this.setState({
                  activityList: configuration,
                  isUserRolesLoading: false
                });
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                this.setState({
                  messageType: 'error',
                  message: 'Unable to retrieve point system configuration.',
                  isUserRolesLoading: false
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function fetchConfiguration() {
        return _fetchConfiguration.apply(this, arguments);
      }

      return fetchConfiguration;
    }()
  }, {
    key: "fetchUserRoles",
    value: function () {
      var _fetchUserRoles = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var res, roles;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _axios.default.get('/role/fetchRoles');

              case 3:
                res = _context3.sent;
                roles = (0, _utils.normalizeRoles)(res.data);
                this.setState({
                  userRoles: roles,
                  isUserRolesLoading: false
                });

              case 6:
                _context3.prev = 6;
                this.setState({
                  isUserRolesLoading: false
                });
                return _context3.finish(6);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0,, 6, 9]]);
      }));

      function fetchUserRoles() {
        return _fetchUserRoles.apply(this, arguments);
      }

      return fetchUserRoles;
    }()
  }, {
    key: "onSave",
    value: function () {
      var _onSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var dataParameters;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  messageType: ''
                });

                if (this.validate()) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                if (!(this.state.selectedTimezone === '')) {
                  _context4.next = 6;
                  break;
                }

                this.setState({
                  timezoneSelectionError: true
                });
                return _context4.abrupt("return");

              case 6:
                this.setState({
                  isSaveButtonLoading: true
                });
                dataParameters = {
                  timezone: this.state.selectedTimezone,
                  activityList: this.state.activityList,
                  excludedUserRoles: this.state.selectedRoles
                };
                _context4.prev = 8;
                _context4.next = 11;
                return _axios.default.post('/settings/pointSystem/configuration', dataParameters);

              case 11:
                this.setState({
                  messageType: 'success',
                  message: 'Changes saved successfully.'
                });
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](8);
                this.setState({
                  messageType: 'error',
                  message: 'Failed to save configuration'
                });

              case 17:
                this.setState({
                  isSaveButtonLoading: false
                });

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 14]]);
      }));

      function onSave() {
        return _onSave.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: "validate",
    value: function validate() {
      // eslint-disable-next-line react/no-access-state-in-setstate
      var activityList = this.state.activityList.map(function (activity) {
        return Object.assign(activity, {
          error: activity.enabled && activity.points < 1 ? 'Please enter a number greater than 0 to enable this rule' : undefined
        });
      });
      this.setState({
        activityList: activityList
      });
      return typeof activityList.find(function (activity) {
        return activity.error;
      }) === 'undefined';
    }
  }, {
    key: "onPointsChange",
    value: function onPointsChange(points, i) {
      // eslint-disable-next-line react/no-access-state-in-setstate
      var activityList = this.state.activityList;
      activityList[i].points = Math.max(points, 0);
      activityList[i].error = undefined;
      this.setState({
        activityList: activityList
      });
    }
  }, {
    key: "onActivityToggle",
    value: function onActivityToggle(activity, i) {
      // eslint-disable-next-line react/no-access-state-in-setstate
      var activityList = this.state.activityList;

      if (!activity.enabled && activity.points < 1) {
        activityList[i].error = 'Please enter a number greater than 0 to enable this rule';
      } else {
        activityList[i].enabled = !activity.enabled;
        activityList[i].error = undefined;
      }

      this.setState({
        activityList: activityList
      });
    }
  }, {
    key: "onUserRolesChanged",
    value: function onUserRolesChanged(data) {
      this.setState({
        isUserRoleDropdownOpen: false,
        selectedRoles: data
      });
    }
  }, {
    key: "onResetUserRoles",
    value: function onResetUserRoles() {
      this.setState({
        isUserRoleDropdownOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var _this$state = this.state,
          messageType = _this$state.messageType,
          message = _this$state.message,
          isSaveButtonLoading = _this$state.isSaveButtonLoading,
          activityList = _this$state.activityList,
          timezoneList = _this$state.timezoneList,
          selectedTimezone = _this$state.selectedTimezone,
          isUserRoleDropdownOpen = _this$state.isUserRoleDropdownOpen,
          isUserRolesLoading = _this$state.isUserRolesLoading,
          userRoles = _this$state.userRoles,
          selectedRoles = _this$state.selectedRoles,
          timezoneSelectionError = _this$state.timezoneSelectionError;
      var isVisibleFor = messageType === 'success' ? 5000 : false;
      return (0, _preact.h)("div", {
        className: "point-system-container"
      }, (0, _preact.h)(_header.default, {
        title: "Point system",
        saveCallback: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
          return _regenerator.default.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this2.onSave();

                case 2:
                  return _context5.abrupt("return", _context5.sent);

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })),
        disableSaveButton: false,
        isLoading: isSaveButtonLoading
      }), (0, _preact.h)(_Section.Section, {
        title: "Point system rules",
        customClass: "point-system-rules"
      }, messageType ? (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        renderHTML: true,
        isVisibleFor: isVisibleFor
      }) : null, activityList.map(function (activity, i) {
        var _activity$enabled;

        return (0, _preact.h)("div", {
          key: i,
          className: (0, _classnames.default)('activity-row', {
            'validation-error': activity.error
          })
        }, (0, _preact.h)(_Switcher.default, {
          customClass: "section-switch",
          on: (_activity$enabled = activity.enabled) !== null && _activity$enabled !== void 0 ? _activity$enabled : false,
          onChange: function onChange() {
            _this2.onActivityToggle(activity, i);
          }
        }), (0, _preact.h)("span", {
          className: "activity-description-left"
        }, "Award "), (0, _preact.h)(_InputGroup.default, {
          key: activity.activityName,
          error: activity.error,
          type: "number",
          min: 0,
          required: true,
          qaClasses: "qa-points",
          placeholder: "0",
          value: activity.points,
          onChangeCallback: function onChangeCallback(e) {
            return _this2.onPointsChange(+e.target.value, i);
          }
        }), (0, _preact.h)("span", {
          className: "activity-description-right"
        }, "points for ", _this2.formattedTextForConfigurableActivities[activity.activityName]));
      })), (0, _preact.h)(_Section.Section, {
        title: "Timezone setting",
        customClass: "point-system-timezone-container"
      }, (0, _preact.h)("div", {
        className: "point-system-timezone-description"
      }, "The weekly user leaderboard automatically resets at midnight on Sunday/Monday according to your timezone selection."), (0, _preact.h)("div", {
        className: "timezone-selector-container"
      }, (0, _preact.h)("label", {
        className: "timezone-selector-label"
      }, "Timezone"), (0, _preact.h)(_TimezoneSelector.default, {
        timezones: timezoneList,
        selected: timezoneList.find(function (timezone) {
          return timezone.value === selectedTimezone;
        }),
        onChange: function onChange(value) {
          _this2.setState({
            timezoneSelectionError: false,
            selectedTimezone: value !== null && value !== void 0 ? value : ''
          });
        },
        error: timezoneSelectionError
      }))), (0, _preact.h)(_Section.Section, {
        title: "Leaderboard page setting",
        customClass: "point-system-leaderboard-page-setting"
      }, (0, _preact.h)("div", {
        className: "point-system-leaderboard-page-setting-description"
      }, "Please note that this setting only applies to", ' ', (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("".concat(props.destinationUrl, "/leaderboard")),
        rel: "noreferrer",
        target: "_blank",
        className: "link"
      }, "leaderboard page"), ", leaderboard widget is not affected. A maximum of 1000 users will be shown on the leaderboard page."), (0, _preact.h)("div", {
        className: "user-role-selector"
      }, (0, _preact.h)("label", {
        className: "user-role-selector-label"
      }, "Select user roles to exclude from leaderboard page"), (0, _preact.h)("div", null, ' ', (0, _preact.h)(_Button.default, {
        disabled: isUserRolesLoading,
        title: (0, _preact.h)("div", null, (0, _preact.h)("span", {
          className: "dropdown-placeholder-text"
        }, " ", getUserRolesPlaceholderText(selectedRoles)), (0, _preact.h)(_ChevronDown.default, {
          className: "dropdown-chevron-down-icon",
          height: 16,
          width: 16
        })),
        size: "medium",
        className: (0, _classnames.default)('user-roles-open-button', 'user-role-selector-button', {
          'dropdown-open': isUserRoleDropdownOpen
        }),
        onClick: function onClick() {
          return _this2.setState({
            isUserRoleDropdownOpen: !isUserRoleDropdownOpen
          });
        }
      }), ' '), isUserRoleDropdownOpen && (0, _preact.h)("div", {
        className: "overview__filters-box-container"
      }, (0, _preact.h)("div", {
        className: "overview__filters-box"
      }, (0, _preact.h)(_SimpleFilterSelector.default, {
        id: "userRole",
        name: "user role ",
        isSearchable: true,
        items: userRoles,
        selectedFilterItems: selectedRoles
      }, function (_ref2) {
        var data = _ref2.data;
        return (0, _preact.h)("div", null, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
          className: "overview__filters-box-buttons"
        }, (0, _preact.h)(_Button.default, {
          size: "small",
          variant: "brand",
          title: "Apply",
          disabled: false,
          onClick: function onClick() {
            return _this2.onUserRolesChanged(data);
          }
        }), (0, _preact.h)(_Button.default, {
          size: "small",
          title: "Cancel",
          onClick: _this2.onResetUserRoles
        })));
      }))))));
    }
  }]);
  return PointSystemConfiguration;
}(_preact.Component);

var _default = PointSystemConfiguration;
exports.default = _default;